import React, {useEffect, useState} from "react";
import {useLocation} from "react-router-dom";
import {IconButton} from "@chakra-ui/react";
import {ArrowUpIcon} from "@chakra-ui/icons";

// Scrolls to the top on page change, or to the section named in the hash (e.g. /#contact).
// Section links re-run on every navigation (location.key) so clicking the same link twice still scrolls;
// query string changes (gallery filters) keep the scroll position.
export function ScrollManager() {
    const {pathname, hash, key} = useLocation();
    const trigger = hash ? key : pathname;

    useEffect(() => {
        if (hash) {
            const target = document.getElementById(decodeURIComponent(hash.slice(1)));
            if (target) {
                target.scrollIntoView({behavior: "smooth", block: "start"});
                return;
            }
        }
        window.scrollTo(0, 0);
    }, [pathname, hash, trigger]);

    return null;
}

export function BackToTop() {
    const [visible, setVisible] = useState(false);

    useEffect(() => {
        const onScroll = () => setVisible(window.scrollY > 700);
        onScroll();
        window.addEventListener("scroll", onScroll, {passive: true});
        return () => window.removeEventListener("scroll", onScroll);
    }, []);

    return (
        <IconButton
            aria-label="Back to top"
            icon={<ArrowUpIcon boxSize={5}/>}
            position="fixed"
            right={{base: 4, md: 8}}
            bottom={{base: 4, md: 8}}
            zIndex="docked"
            borderRadius="full"
            size="lg"
            colorScheme="gray"
            bg="ink.900"
            color="white"
            _hover={{bg: "brand.500"}}
            boxShadow="lg"
            opacity={visible ? 1 : 0}
            pointerEvents={visible ? "auto" : "none"}
            transition="opacity 0.3s, background 0.2s"
            onClick={() => window.scrollTo({top: 0, behavior: "smooth"})}
        />
    );
}
